import { isTokenValid } from "@/helpers/jwt"
import { useAppSelector } from "@/store"
import { PlayerSelectors } from "@/store/slices/player"

export const useHasSession = (): boolean => {
  const isAuthorized = useAppSelector(PlayerSelectors.selectIsAuthorized())

  return (
    isAuthorized || isTokenValid("accessToken") || isTokenValid("refreshToken")
  )
}
